module.exports = __webpack_public_path__ + "img/charm_9.bd1464c8.png";